import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHeaderSlider } from '../../components/NewbuildingHeaderSlider';
import { NewbuildingHeaderSliderWrapper } from '../../components/NewbuildingHeaderSliderWrapper';
import { newbuildingFullscreenMediaSettings } from '../../constants/newbuildingFullscreenMediaSettings';
import { getImages, getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackMediaItemClick } from '../../tracking/newbuilding';
import { NewbuildingHeaderFullscreenGalleryContainerLoadable } from '../NewbuildingHeaderFullscreenGallery';

export const NewbuildingHeaderSliderContainer: React.FC = () => {
  const [isFullscreenOpened, toggleFullscreen] = React.useState(false);

  const images = useSelector(getImages);
  const newbuildingId = useSelector(getNewbuildingId);

  const handleSliderClick = React.useCallback(() => {
    toggleFullscreen(true);

    if (newbuildingId) {
      trackMediaItemClick({ target: 'gallery', newbuildingId });
    }
  }, [newbuildingId]);

  const handleFullscreenGalleryClose = React.useCallback(() => {
    toggleFullscreen(false);
  }, []);

  if (images.length === 0) {
    return null;
  }

  return (
    <NewbuildingHeaderSliderWrapper>
      <NewbuildingHeaderSlider images={images} onClick={handleSliderClick} />
      {isFullscreenOpened && (
        <NewbuildingHeaderFullscreenGalleryContainerLoadable
          images={images}
          onClose={handleFullscreenGalleryClose}
          settings={newbuildingFullscreenMediaSettings}
        />
      )}
    </NewbuildingHeaderSliderWrapper>
  );
};
